export default __webpack_public_path__ + "ec7d0583b3fdf189858ca4ab0e0f8845.png";